<template>
    <v-sheet class="languageCard" color="transparent">
      <v-row class="ma-0 py-3" justify="end" align-content="center">
        <v-select
        class="languageSelect"
        v-if="!xs"
        v-model="locale"
        :items="language"
        item-title="title"
        item-value="value"
        density="compact"
        variant="outlined"
        hide-details
        style="width: 110px !important;"
        >
        </v-select>
                  
        <v-menu
          :close-on-content-click="false"
          transition="slide-x-transition"
        >
        
          <template v-slot:activator="{ props, isActive }">
            <v-btn
              :append-icon="isActive?'mdi-chevron-left':'mdi-chevron-down'"
              color="colorText"
              v-bind="props"
            >
              <v-icon icon="mdi-cog-outline"></v-icon>
            </v-btn>
          </template>
          <v-list 
              :lines="false"
              density="compact"
              nav
              >

              <!-- Theme Switch -->
              <v-list-item>
                <v-switch 
                v-model="themeSwitch" 
                append-icon="mdi-weather-night" 
                prepend-icon="mdi-white-balance-sunny"
                hide-details
                >
                </v-switch> 
              </v-list-item>
              <v-list-item v-if="xs">
                <v-select
                class="mb-3"
                v-model="locale"
                :items="language"
                item-title="title"
                item-value="value"
                density="compact"
                variant="outlined"
                hide-details
                style="width: 110px !important;"
                >
                </v-select>
              </v-list-item>
              <v-list-item
                  :style="'text-align:center'"
                  v-for="(item, i) in items"
                  :key="i"
                  link
                  @click="pressItem(i)"
              >
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
              
          </v-list>
        </v-menu>
      </v-row>

    </v-sheet>
</template>

<script setup lang="ts">
import { ref, watch, computed, onMounted } from 'vue';

import router         from '@/router';

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useTheme, useDisplay } from 'vuetify';
const { xs }= useDisplay();
const theme = useTheme();

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from 'vue-i18n';
let { locale, t } = useI18n();

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from 'vuex';
const store = useStore();


const items           = ref([
  {title : computed( () => t('logout') )}
]);

const language        = ref([ 
  { title: computed(() => t('appBar.es')), value: 'es' },
  { title: computed(() => t('appBar.en')), value: 'en' },
])


const themeSwitch     = ref(false);

watch(themeSwitch,(p:boolean)=>{
  setTimeout(() => {
    localStorage.setItem('appTheme', p.toString());
    let themeSelect = '';
    p ? themeSelect = 'darkCustom' : themeSelect = 'lightCustom';
    theme.global.name.value = themeSelect;
  }, 100);
})


const pressItem       = (item:number) => {
  if(item === 0){
    router.push('/')
    setTimeout(()=>{
        localStorage.removeItem('user');
        localStorage.removeItem('rol');
        router.push('/login');
        store.commit('setAppBarPage','principalPage');
        store.commit('setUserSesion',null);

        //PARA CUANDO HAYAN 2 smartlink en el mismo lugar
        // router.push(`/principalPage`);
        // store.commit('setAppBarPage','principalPage');
    },200)
  }
  if(item === 1 ){
    if(theme.global.name.value === 'darkCustom'){
      theme.themes.value.darkCustom.colors.background = '#FF00FF'
    }
    if(theme.global.name.value === 'lightCustom'){
      theme.themes.value.lightCustom.colors.background = '#FF0000'
    }
  }
}

onMounted(() => {
  let themeSelect = '';
  localStorage.getItem('appTheme') === null ? localStorage.setItem('appTheme','true') : null;
  setTimeout(() => {
    themeSwitch.value = localStorage.getItem('appTheme')?.toString() === 'true'
    themeSwitch.value ? themeSelect = 'darkCustom' : themeSelect = 'lightCustom';
    theme.global.name.value = themeSelect;
  }, 500);
})

</script>

<style scoped>

</style>